module.exports = __webpack_public_path__ + "img/03.14111fe6.png";